var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Drawer, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import { List, TextField, TextInput, useDelete, DatagridConfigurable } from "react-admin";
import { Dialog } from "@sequentech/ui-essentials";
import { ListActions } from "@/components/ListActions";
import { ActionsColumn } from "@/components/ActionButons";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { SettingsTrusteesCreate } from "./SettingsTrusteesCreate";
import { SettingsTrusteesEdit } from "./SettingsTrusteesEdit";
import { PasswordDialog } from "@/components/election-event/export-data/PasswordDialog";
import { useMutation } from "@apollo/client";
import { EXPORT_TRUSTEES } from "@/queries/ExportTrustees";
import { generateRandomPassword } from "@/services/Password";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { ETasksExecution } from "@/types/tasksExecution";
import { FormStyles } from "@/components/styles/FormStyles";
import { DownloadDocument } from "../User/DownloadDocument";
import { ThreeStateDatagridHeader } from "@/components/ThreeStateDatagridHeader";
var EmptyBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n"])));
var useActionPermissions = function () {
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    var canCreateTrustee = authContext.isAuthorized(true, tenantId, IPermissions.TRUSTEE_WRITE);
    var canReadTrustee = authContext.isAuthorized(true, tenantId, IPermissions.TRUSTEE_READ);
    var canExportTrustees = authContext.isAuthorized(true, tenantId, IPermissions.TRUSTEES_EXPORT);
    return {
        canCreateTrustee: canCreateTrustee,
        canReadTrustee: canReadTrustee,
        canExportTrustees: canExportTrustees,
    };
};
var OMIT_FIELDS = ["id", "public_key"];
var Filters = [
    _jsx(TextInput, { label: "Name", source: "name" }, 0),
    _jsx(TextInput, { label: "Public Key", source: "public_key" }, 0),
];
export var SettingsTrustees = function () {
    var t = useTranslation().t;
    var deleteOne = useDelete()[0];
    var _a = useActionPermissions(), canCreateTrustee = _a.canCreateTrustee, canReadTrustee = _a.canReadTrustee, canExportTrustees = _a.canExportTrustees;
    var _b = useWidgetStore(), addWidget = _b[0], setWidgetTaskId = _b[1], updateWidgetFail = _b[2];
    var _c = React.useState(false), open = _c[0], setOpen = _c[1];
    var _d = React.useState(false), openDeleteModal = _d[0], setOpenDeleteModal = _d[1];
    var _e = React.useState(), deleteId = _e[0], setDeleteId = _e[1];
    var _f = React.useState(false), openDrawer = _f[0], setOpenDrawer = _f[1];
    var _g = React.useState(undefined), recordId = _g[0], setRecordId = _g[1];
    var _h = React.useState(false), loadingExport = _h[0], setLoadingExport = _h[1];
    var _j = React.useState(null), exportDocumentId = _j[0], setExportDocumentId = _j[1];
    var _k = React.useState(false), openPasswordDialog = _k[0], setOpenPasswordDialog = _k[1];
    var _l = React.useState(null), password = _l[0], setPassword = _l[1];
    var exportTrustees = useMutation(EXPORT_TRUSTEES, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.TRUSTEES_EXPORT,
            },
        },
    })[0];
    useEffect(function () {
        if (recordId) {
            setOpen(true);
        }
    }, [recordId]);
    var handleCloseCreateDrawer = function () {
        setRecordId(undefined);
        setOpenDrawer(false);
        setOpen(false);
    };
    var handleOpenCreateDrawer = function () {
        setRecordId(undefined);
        setOpenDrawer(true);
        setOpen(false);
    };
    var handleCloseEditDrawer = function () {
        setOpen(false);
        setTimeout(function () {
            setRecordId(undefined);
        }, 400);
    };
    var editAction = function (id) {
        setRecordId(id);
    };
    var deleteAction = function (id) {
        setOpenDeleteModal(true);
        setDeleteId(id);
    };
    var confirmDeleteAction = function () {
        deleteOne("sequent_backend_trustee", { id: deleteId });
        setDeleteId(undefined);
    };
    var actions = [
        { icon: _jsx(EditIcon, {}), action: editAction },
        { icon: _jsx(DeleteIcon, {}), action: deleteAction },
    ];
    var CreateButton = function () { return (_jsx(Button, { onClick: handleOpenCreateDrawer, startIcon: _jsx(AddIcon, {}), children: t("trusteesSettingsScreen.common.createNew") })); };
    var Empty = function () { return (_jsxs(EmptyBox, { m: 1, children: [_jsx(Typography, { variant: "h4", paragraph: true, children: t("trusteesSettingsScreen.common.emptyHeader") }), canCreateTrustee ? (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body1", paragraph: true, children: t("electionTypeScreen.common.emptyBody") }), _jsx(CreateButton, {})] })) : null] })); };
    if (!canReadTrustee) {
        return _jsx(Empty, {});
    }
    var resetState = function () {
        setOpenPasswordDialog(false);
        setPassword(null);
        setLoadingExport(false);
        setExportDocumentId(null);
    };
    var doExport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, generatedPassword, _a, exportTrusteesData, errors, documentId, task_id, error_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    currWidget = addWidget(ETasksExecution.EXPORT_TRUSTEES, undefined);
                    setLoadingExport(true);
                    generatedPassword = generateRandomPassword();
                    setPassword(generatedPassword);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, exportTrustees({
                            variables: {
                                password: generatedPassword,
                            },
                        })];
                case 2:
                    _a = _d.sent(), exportTrusteesData = _a.data, errors = _a.errors;
                    documentId = (_b = exportTrusteesData === null || exportTrusteesData === void 0 ? void 0 : exportTrusteesData.exportTrustees) === null || _b === void 0 ? void 0 : _b.document_id;
                    if (errors || !documentId) {
                        updateWidgetFail(currWidget.identifier);
                        console.log("Error exporting users: ".concat(errors));
                        resetState();
                        return [2 /*return*/];
                    }
                    task_id = (_c = exportTrusteesData === null || exportTrusteesData === void 0 ? void 0 : exportTrusteesData.exportTrustees) === null || _c === void 0 ? void 0 : _c.task_execution.id;
                    setWidgetTaskId(currWidget.identifier, task_id);
                    setExportDocumentId(documentId);
                    setOpenPasswordDialog(true);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _d.sent();
                    console.log(error_1);
                    updateWidgetFail(currWidget.identifier);
                    resetState();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(List, { filters: Filters, actions: _jsx(ListActions, { custom: true, withFilter: true, withAction: canCreateTrustee, doAction: handleOpenCreateDrawer, actionLabel: "common.label.add", isExportDisabled: openPasswordDialog || loadingExport, withExport: canExportTrustees, doExport: doExport }), empty: _jsx(Empty, {}), children: _jsxs(DatagridConfigurable, { header: ThreeStateDatagridHeader, omit: OMIT_FIELDS, children: [_jsx(TextField, { source: "id" }), _jsx(TextField, { source: "public_key" }), _jsx(TextField, { source: "name" }), _jsx(ActionsColumn, { actions: actions })] }) }), _jsx(Drawer, { anchor: "right", open: openDrawer, onClose: handleCloseCreateDrawer, PaperProps: {
                    sx: { width: "40%" },
                }, children: _jsx(SettingsTrusteesCreate, { close: handleCloseCreateDrawer }) }), _jsx(Drawer, { anchor: "right", open: open, onClose: handleCloseEditDrawer, PaperProps: {
                    sx: { width: "40%" },
                }, children: _jsx(SettingsTrusteesEdit, { id: recordId, close: handleCloseEditDrawer }) }), _jsx(Dialog, { variant: "warning", open: openDeleteModal, ok: String(t("common.label.delete")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) {
                    if (result) {
                        confirmDeleteAction();
                    }
                    setOpenDeleteModal(false);
                }, children: t("common.message.delete") }), exportDocumentId && (_jsxs(_Fragment, { children: [_jsx(FormStyles.ShowProgress, {}), _jsx(DownloadDocument, { documentId: exportDocumentId, fileName: "trustees-export.ezip", onDownload: function () {
                            setExportDocumentId(null);
                        }, onSuccess: function () { return undefined; } })] })), openPasswordDialog && password && (_jsx(PasswordDialog, { password: password, onClose: resetState }))] }));
};
var templateObject_1;
